import React from "react";
import styled from "styled-components";
import { P } from "../Texts";

const CircleRadioStyle = styled.input`
  position: absolute;
  opacity: 0;
  width: 16px; /* Match the CircleStyle */
  height: 16px; /* Match the CircleStyle */
  cursor: pointer;

  & + label .check-holder > div {
    background: transparent;
    transition: background 0.2s ease;
  }

  &:checked + label .check-holder > div {
    background: #442ed0;
  }
`;

const CircleStyle = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #442ed0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  > div {
    width: 10px;
    height: 10px;
    border-radius: 100%;
  }
`;

export const CircleRadio = React.forwardRef(
  (
    {
      className,
      id,
      name,
      label,
      onChange,
      checked,
      labelColor = "#1E202A",
      value,
      required,
      ...rest
    },
    ref,
  ) => {
    return (
      <div className="relative flex items-center">
        <CircleRadioStyle
          type="radio"
          ref={ref}
          name={name}
          id={id}
          value={value}
          required={required}
          checked={checked}
          onChange={onChange}
          className="absolute"
        />
        {label && (
          <label htmlFor={id} className="flex items-center cursor-pointer">
            <CircleStyle className="check-holder flex items-center justify-center">
              <div></div>
            </CircleStyle>
            <P color={labelColor} {...rest} className="ml-4">
              {label}
            </P>
          </label>
        )}
      </div>
    );
  },
);
